import { Users, Library, Heart } from "lucide-react";
import { CIRCLES_STATS } from "./circlesContent";
import { SHELVES_STATS } from "./shelvesContent";

export const HOME_CIRCLES_HIGHLIGHTS = [
  {
    icon: Users,
    title: "Reader Circles",
    desc: "Small groups of readers sharing weekly highlights and thoughtful takes.",
    metric: CIRCLES_STATS[0].value,
    metricLabel: CIRCLES_STATS[0].label,
  },
  {
    icon: Library,
    title: "Shared Collections",
    desc: "Curated themed shelves like modern fiction, memoir, and timeless classics.",
    metric: SHELVES_STATS[0].value,
    metricLabel: SHELVES_STATS[0].label,
  },
  {
    icon: Heart,
    title: "Books in Conversation",
    desc: "Discover books that spark discussion and get recommended by fellow members.",
    metric: CIRCLES_STATS[2].value,
    metricLabel: "avg reader rating",
  },
];
